import { render, staticRenderFns } from "./SettingsSubPageHeader.vue?vue&type=template&id=d17de3e8&"
import script from "./SettingsSubPageHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsSubPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d17de3e8')) {
      api.createRecord('d17de3e8', component.options)
    } else {
      api.reload('d17de3e8', component.options)
    }
    module.hot.accept("./SettingsSubPageHeader.vue?vue&type=template&id=d17de3e8&", function () {
      api.rerender('d17de3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue"
export default component.exports